// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  margin-top: 32px;
  margin-bottom: 8px;
`;
Section.displayName = 'S.Section';

export const SectionTitle = styled.div`
  flex: 1 1 auto;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
SectionTitle.displayName = 'S.SectionTitle';

export const CollapsibleTable = styled.div`
  max-height: 650px;
`;
CollapsibleTable.displayName = 'S.CollapsibleTable';
